import { Search } from "@aircall/react-icons";
import { HeaderSimple } from "@/playground/components/DevHome/table/pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { ColumnType } from "../columns.decl";

export const resultsCountConfig: ColumnType = {
  id: "resultsCount",
  label: <HeaderSimple label="result" />,
  renderer: ({ resultsCount }) => (
    <div className="flex items-center gap-1.5 text-xs">
      <Search className="size-4 text-muted-foreground" />
      <span>{resultsCount}</span>
    </div>
  ),
};
